import React from 'react';
import { i18n } from '../translate/i18n';
import getReason from './getReason';
import {
	Tooltip, Typography
} from "@mui/material";
import {
	RemoveCircle, OfflineBolt, CheckCircleRounded, CancelRounded, Check, Help, MoreHoriz
} from '@mui/icons-material'

export const renderStatusIcon = (equip) => {

	if(equip.active === false) {
		return <Tooltip title={i18n.t('statusManipulation.title1')}><RemoveCircle style={{ color: renderStatusColor(equip) }} /></Tooltip>
	}

	if(equip.statusGlobal === 'maintenance' && equip.active === true) {
		return <Tooltip title={i18n.t('statusManipulation.title2')}><OfflineBolt style={{ color: renderStatusColor(equip) }} /></Tooltip>
	}

	switch (equip.statusGlobal) {
		case 'not defined': return <Tooltip title={i18n.t('statusManipulation.title5')}><MoreHoriz style={{ color: renderStatusColor(equip) }} /></Tooltip>
		case 'inactive': return <Tooltip title={i18n.t('statusManipulation.title1')}><RemoveCircle style={{ color: renderStatusColor(equip) }} /></Tooltip>
		case 'maintenance': return <Tooltip title={i18n.t('statusManipulation.title2')}><OfflineBolt style={{ color: renderStatusColor(equip) }} /></Tooltip>
		case 'valid': return <Tooltip title={i18n.t('statusManipulation.title3')}><CheckCircleRounded style={{ color: renderStatusColor(equip) }} /></Tooltip>
		case 'invalid': return <Tooltip title={`${i18n.t('statusManipulation.title4')}. ${getReason(equip)}`}><CancelRounded style={{ color: renderStatusColor(equip) }} /></Tooltip>
		case 'validWithOpenedActions': return <Tooltip title={`${i18n.t('statusManipulation.title6')}. ${getReason(equip)}`}><CheckCircleRounded style={{ color: renderStatusColor(equip) }} /></Tooltip>
		default: return <Tooltip title={i18n.t('statusManipulation.title7')}><Check style={{ color: renderStatusColor(equip) }} /></Tooltip>
	}
}

export const renderStatusColor = (equip) => {
	if(equip.active === false) {
		return 'gray';
	}

	if(equip.statusGlobal === 'maintenance' && equip.active === true) {
		return 'darkblue';
	}

	switch (equip.statusGlobal) {
		case 'not defined': return '#fcbe03';
		case 'inactive': return 'gray';
		case 'maintenance': return 'darkblue';
		case 'valid': return 'green';
		case 'invalid': return '#e57878';
		case 'validWithOpenedActions': return '#fcbe03';
		default: return 'grey';
	}
}

export const renderStatusReason = (equip) => {
	switch (equip.statusGlobal) {
		case 'inactive': return <Typography>{i18n.t('statusManipulation.title1')}</Typography>
		case 'maintenance': return <Typography>{i18n.t('statusManipulation.title2')}</Typography>
		case 'valid': return <Typography>{i18n.t('statusManipulation.title3')}</Typography>
		case 'invalid': return <Typography>{`${i18n.t('statusManipulation.title4')}. ${getReason(equip)}`}</Typography>
		case 'validWithOpenedActions': return <Typography title={`${i18n.t('statusManipulation.title6')}. ${getReason(equip)}`}></Typography>
		default: return <Typography>{i18n.t('statusManipulation.title7')}</Typography>
	}
}

